/**
 * 所有客户月度流水 - 每个客户单独一个折线图，分页查看
 * 数据中心 > 月度流水
 */
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item>月度流水</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card shadow="never" class="flow-card">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="商户">
          <el-input
            v-model="formInline.merchantName"
            placeholder="请输入商户名称"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="formInline.startMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="开始月份"
            style="width: 130px"
          />
          <span style="margin: 0 8px">至</span>
          <el-date-picker
            v-model="formInline.endMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="结束月份"
            style="width: 130px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div v-loading="loading">
        <div
          v-for="(item, index) in listData"
          :key="item.merchantId || index"
          class="chart-item-card"
        >
          <div class="chart-item-title">{{ item.merchantName || '商户' + (item.merchantId || index + 1) }}</div>
          <div :ref="'chartRef' + index" class="chart-single-wrap"></div>
        </div>
        <div v-if="!loading && listData.length === 0" class="chart-empty">暂无数据</div>
      </div>

      <Pagination v-bind:child-msg="pageparm" @callFather="callFather" />
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { getSalesAllCustomersMonthlyFlowList } from '@/api/userMG';
import Pagination from '@/components/Pagination';

export default {
  name: 'AllCustomersMonthlyFlow',
  components: { Pagination },
  data() {
    const now = new Date();
    const startMonth = `${now.getFullYear()}-01`;
    const endMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    return {
      formInline: {
        merchantName: '',
        startMonth,
        endMonth,
        page: 1,
        pageSize: 10,
      },
      loading: false,
      listData: [],
      chartInstances: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.search();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.disposeAllCharts();
  },
  methods: {
    getMonthRange(startMonth, endMonth) {
      const [y1, m1] = startMonth.split('-').map(Number);
      const [y2, m2] = endMonth.split('-').map(Number);
      const list = [];
      let y = y1;
      let m = m1;
      while (y < y2 || (y === y2 && m <= m2)) {
        list.push(`${y}-${String(m).padStart(2, '0')}`);
        if (m === 12) {
          y += 1;
          m = 1;
        } else {
          m += 1;
        }
      }
      return list;
    },
    search() {
      const start = this.formInline.startMonth;
      const end = this.formInline.endMonth;
      if (!start || !end) {
        this.$message.warning('请选择时间范围');
        return;
      }
      const [y1, m1] = start.split('-').map(Number);
      const [y2, m2] = end.split('-').map(Number);
      const monthDiff = (y2 - y1) * 12 + (m2 - m1);
      if (monthDiff < 0) {
        this.$message.warning('结束月份不能早于开始月份');
        return;
      }
      if (monthDiff > 12) {
        this.$message.warning('时间范围最大不超过1年');
        return;
      }
      this.formInline.page = this.pageparm.page;
      this.formInline.pageSize = this.pageparm.pageSize;
      this.loading = true;
      getSalesAllCustomersMonthlyFlowList({
        merchantName: this.formInline.merchantName || undefined,
        startDate: start,
        endDate: end,
        page: this.formInline.page,
        pageSize: this.formInline.pageSize,
      })
        .then((res) => {
          if (res.msg === 'success' && res.data) {
            const data = res.data;
            this.listData = data.items || [];
            this.pageparm.total = data.totalCount != null ? data.totalCount : 0;
            this.pageparm.page = data.page != null ? data.page : 1;
            this.pageparm.pageSize = data.pageSize != null ? data.pageSize : 10;
            this.$nextTick(() => this.renderAllCharts());
          } else {
            this.listData = [];
            this.pageparm.total = 0;
            this.disposeAllCharts();
          }
        })
        .catch(() => {
          this.listData = [];
          this.pageparm.total = 0;
          this.disposeAllCharts();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    disposeAllCharts() {
      this.chartInstances.forEach((ch) => {
        if (ch && ch.dispose) ch.dispose();
      });
      this.chartInstances = [];
    },
    renderAllCharts() {
      this.disposeAllCharts();
      const refs = this.$refs;
      this.listData.forEach((item, index) => {
        const refName = 'chartRef' + index;
        const el = refs[refName];
        const dom = Array.isArray(el) ? el[0] : el;
        if (!dom) return;
        const chart = echarts.init(dom);
        this.chartInstances.push(chart);
        const monthlyData = (item.monthlyData || []).slice();
        monthlyData.sort((a, b) => {
          const ymA = (a.yearMonth || a.monthKey || '').toString();
          const ymB = (b.yearMonth || b.monthKey || '').toString();
          return ymA.localeCompare(ymB);
        });
        const months = [];
        const values = [];
        monthlyData.forEach((d) => {
          const ym = (d.yearMonth || d.monthKey || '').toString();
          if (!ym) return;
          months.push(ym);
          const amt = Number(d.preTaxAmount);
          values.push(amt != null && !isNaN(amt) ? amt : 0);
        });
        const monthLabels = months.map((ym) => {
          const s = String(ym);
          return s.length >= 7 && s.indexOf('-') !== -1 ? s.replace('-', '年') + '月' : s;
        });
        const aggregated = values.map((v, i) => ({
          yearMonth: months[i] || '',
          monthLabel: monthLabels[i] || '',
          preTaxAmount: v != null ? v : 0,
        }));
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'line' },
            formatter: (params) => {
              if (!params || !params.length) return '';
              const idx = params[0].dataIndex;
              const ym = months[idx] || '';
              const amt = aggregated[idx] ? aggregated[idx].preTaxAmount : 0;
              return `${ym}<br/>下发税前金额：${Number(amt).toFixed(2)} 元`;
            },
          },
          grid: { left: 56, right: 32, bottom: 36, top: 36, containLabel: true },
          xAxis: {
            type: 'category',
            data: monthLabels.length ? monthLabels : ['暂无数据'],
            axisLine: { lineStyle: { color: '#e4e7ed' } },
            axisLabel: { color: '#606266', fontSize: 12 },
          },
          yAxis: {
            type: 'value',
            name: '流水(元)',
            nameTextStyle: { color: '#606266', fontSize: 12 },
            axisLine: { show: false },
            splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } },
            axisLabel: { color: '#606266', fontSize: 12 },
          },
          series: [
            {
              name: '流水',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 6,
              data: values.length ? values : [0],
              itemStyle: { color: '#409EFF' },
              lineStyle: { width: 2 },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: 'rgba(64, 158, 255, 0.25)' },
                    { offset: 1, color: 'rgba(64, 158, 255, 0.02)' },
                  ],
                },
              },
            },
          ],
        };
        chart.setOption(option, true);
      });
      this.$nextTick(() => this.chartInstances.forEach((ch) => ch && ch.resize()));
    },
    handleResize() {
      this.chartInstances.forEach((ch) => ch && ch.resize());
    },
    callFather(parm) {
      this.pageparm.page = parm.page;
      this.pageparm.pageSize = parm.pageSize;
      this.search();
    },
    reset() {
      const now = new Date();
      this.formInline.merchantName = '';
      this.formInline.startMonth = `${now.getFullYear()}-01`;
      this.formInline.endMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      this.formInline.page = 1;
      this.pageparm.page = 1;
      this.pageparm.pageSize = 10;
      this.listData = [];
      this.disposeAllCharts();
      this.search();
    },
  },
};
</script>

<style scoped>
.flow-card {
  margin-top: 16px;
}
.search-form {
  margin-bottom: 16px;
}
.search-form .el-form-item {
  margin-bottom: 0;
}
.chart-item-card {
  margin-bottom: 24px;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
}
.chart-item-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 12px;
}
.chart-single-wrap {
  width: 100%;
  height: 320px;
}
.chart-empty {
  text-align: center;
  color: #909399;
  padding: 80px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/sales/allCustomersMonthlyFlow.vue